<app-home-header></app-home-header>

<div class="main-content">
  <router-outlet></router-outlet>
</div>

<app-home-footer></app-home-footer>
